import { render, staticRenderFns } from "./LineItem.vue?vue&type=template&id=28f11f90&lang=pug"
import script from "./LineItem.vue?vue&type=script&lang=js"
export * from "./LineItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports